<div class="container">
  <div class="row">
    <div class="col" style="text-align: center">
      <ng-template  [ngIf]="sessionIsActive"><div class="emprez-vert-agrume">
        <i class="fad fa-shield-check fa-lg"></i>&nbsp;{{'SessionWithAPIIsValid' | translate}}
        <!--
        <div>
          <button class="btn btn-secondary" [ngbTooltip]="'VerifyConnection' | translate" (click)="verifyConnection()"><i class="fa fa-sync fa-lg"></i> {{'VerifyConnection' | translate}}</button>
        </div>
        -->
      </div>
      </ng-template>
      <ng-template [ngIf]="!sessionIsActive">
        <div class="emprez-rouge-matador">
            <i class="fad fa-times-circle fa-lg"></i>&nbsp;{{'SessionWithAPIIsNotValid' | translate}}
            <div>
              <button class="btn btn-secondary" [ngbTooltip]="'VerifyConnection' | translate" (click)="verifyConnection()"><i class="fa fa-sync fa-lg"></i> {{'VerifyConnection' | translate}}</button>
              <!--        <a class="naked emprez-duo-icon" [ngbTooltip]="'VerifyConnection' | translate" (click)="verifyConnection()"><i class="fad fa-sync"></i></a>-->
            </div>
        </div>
      </ng-template>

    </div>
  </div>

  <div style="margin-top: 1rem;">&nbsp;</div>

  <div class="row">
    <div class="col" style="text-align: center;">
      <ng-template [ngIf]="!sessionIsActive">
      <div >
        <button class="btn btn-primary" (click)="connectToCgi()"><i class="fa fa-plug fa-lg"></i>&nbsp;{{'ConnectToAPI' | translate}}</button>
      </div>
      </ng-template>
    </div>
  </div>

</div>



